import { applyMiddleware, createStore } from "redux"
import { thunk } from "redux-thunk"

let initialState={
    userData:{

    }
}

export let userReducer=(state=initialState,action)=>{
    switch(action.type){
        case "add":{
            return {...state,userData:action.payload}
        }
        default :{
            return state
        }
    }
}

export let store3=createStore(userReducer,applyMiddleware(thunk));
